/* istanbul ignore file */
import ToastNotification from './ToastNotification';

export default ToastNotification;
